import React from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';
import NextLink from 'src/components/atoms/link';
import { BASE_URL, ROUTES } from 'src/helpers/constants';

const OnlineCourse = () => {
  const { t } = useTranslation('common');
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: { lg: 'unset', md: '40%', sx: 'unset' } }}>
      <Typography variant="h5" color={theme.palette.primaryV2.main}>
        {t('home.footer.courses_online')}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography
          variant="body2lanna"
          href={ROUTES.ALL_COURSE}
          color={theme.palette.primaryV2.main}
          component={NextLink}
        >
          {t('home.footer.all_courses')}
        </Typography>
        <Typography
          variant="body2lanna"
          href="/academic/tuxsa"
          color={theme.palette.primaryV2.main}
          component={NextLink}
        >
          {t('home.footer.tuxsa')}
        </Typography>
        <Typography
          variant="body2lanna"
          href={ROUTES.BUSINESS}
          color={theme.palette.primaryV2.main}
          component={NextLink}
        >
          {t('home.footer.business')}
        </Typography>
        <Typography
          variant="body2lanna"
          href={`${BASE_URL.CERTIFICATE_URL}/check`}
          color={theme.palette.primaryV2.main}
          target="_blank"
          component={NextLink}
        >
          {t('home.footer.check_cert')}
        </Typography>
      </Box>
    </Box>
  );
};

export default OnlineCourse;
